import { PureComponent } from 'react';

import { ButtonAsA } from 'components/Button/ButtonAsA';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { withAppProps } from 'utils/react/withAppProps';
import ErrorsSummary from './ErrorsSummary';
import ErrorsSummaryIcon from './ErrorsSummaryIcon';
import InProgress from './InProgress';
import Inventory from './Inventory';
import Logs from './Logs';

export const defaultTab = 'inventoryTab';
export const inventoryTab = 'inventoryTab';
export const queueTab = 'queueTab';
export const serviceLogsTab = 'serviceLogsTab';
export const errorsSummaryTab = 'errorsSummaryTab';

@withAppProps
export default class Tabs extends PureComponent {
  static propTypes = {
    exceptionsMsg: PropTypes.object.isRequired,
    hostnameTableDetailMsg: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    isRunning: PropTypes.bool,
    location: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    newSnapshot: PropTypes.bool.isRequired,
    recalculating: PropTypes.bool,
    scheduledJob: PropTypes.bool.isRequired,
    selectedSnapshot: PropTypes.string,
    snapshotDone: PropTypes.bool,
    snapshotId: PropTypes.string,
  };

  getTabClassName = (activeTab) => {
    if (this.getActiveTab() === activeTab) {
      return 'active';
    }
    return '';
  };

  getTabContentClassName = (activeTab) => {
    if (this.getActiveTab() === activeTab) {
      return 'active tab-pane snapshot-full-width';
    }
    return 'tab-pane snapshot-full-width';
  };

  getActiveTab = () => {
    const hash = get(this.props, 'location.hash', '').replace('#', '');
    return hash || defaultTab;
  };

  handleOnClickTab = (activeTab) => {
    const { navigate, location } = this.props;

    navigate(`${location.pathname}#${activeTab}`, { replace: true });
  };

  render() {
    const {
      exceptionsMsg,
      hostnameTableDetailMsg,
      isLoading,
      isRunning,
      msg,
      newSnapshot,
      scheduledJob,
      selectedSnapshot,
      snapshotDone,
      snapshotId,
      recalculating,
    } = this.props;
    const activeTab = this.getActiveTab();
    return (
      <div className='snapshots-content__tabs'>
        <div className='nav-tabs-custom snapshot-full-width mb-0'>
          <ul className='nav nav-tabs'>
            <li className={this.getTabClassName(inventoryTab)}>
              <ButtonAsA
                onClick={() => this.handleOnClickTab(inventoryTab)}
                data-toggle='tab'
                aria-expanded='true'
              >
                {get(msg, 'discovery.devicesInventory.tabTitle')}
              </ButtonAsA>
            </li>
            <li className={this.getTabClassName(serviceLogsTab)}>
              <ButtonAsA
                onClick={() => this.handleOnClickTab(serviceLogsTab)}
                data-toggle='tab'
                aria-expanded='true'
              >
                {get(msg, 'discovery.servicesLogs.tabTitle')}
              </ButtonAsA>
            </li>
            <li className={this.getTabClassName(queueTab)}>
              <ButtonAsA
                onClick={() => this.handleOnClickTab(queueTab)}
                data-toggle='tab'
                aria-expanded='true'
              >
                {get(msg, 'discovery.devicesInProgress.tabTitle')}
              </ButtonAsA>
            </li>
            <li className={this.getTabClassName(errorsSummaryTab)}>
              <ButtonAsA
                onClick={() => this.handleOnClickTab(errorsSummaryTab)}
                data-toggle='tab'
                aria-expanded='true'
              >
                {get(msg, 'discovery.errorsSummary.tabTitle')}
                <ErrorsSummaryIcon snapshotId={snapshotId} />
              </ButtonAsA>
            </li>
          </ul>
          <div className='snapshot-full-width snapshots-content__tabs-content p-4'>
            {activeTab === inventoryTab && (
              <div
                className={`${this.getTabContentClassName(inventoryTab)} flex flex-col`}
              >
                <Inventory
                  msg={get(msg, 'discovery.devicesInventory') || {}}
                  snapshotId={snapshotId}
                  isRunning={isRunning}
                  isLoading={isLoading}
                  newSnapshot={newSnapshot}
                  scheduledJob={scheduledJob}
                  selectedSnapshot={selectedSnapshot}
                  hostnameTableDetailMsg={hostnameTableDetailMsg}
                  snapshotsMsg={msg}
                  recalculating={recalculating}
                />
              </div>
            )}
            {activeTab === queueTab && (
              <div
                className={`snapshots-content__tabs-content-wrapper relative ${this.getTabContentClassName(queueTab)}`}
              >
                <InProgress
                  msg={get(msg, 'discovery.devicesInProgress') || {}}
                  snapshotId={snapshotId}
                  isRunning={isRunning}
                  isLoading={isLoading}
                  newSnapshot={newSnapshot}
                  snapshotDone={snapshotDone}
                  selectedSnapshot={selectedSnapshot}
                  hostnameTableDetailMsg={hostnameTableDetailMsg}
                  snapshotsMsg={msg}
                />
              </div>
            )}
            {activeTab === serviceLogsTab && (
              <div
                className={`snapshots-content__tabs-content-wrapper relative ${this.getTabContentClassName(serviceLogsTab)}`}
              >
                <Logs msg={msg} newSnapshot={newSnapshot} />
              </div>
            )}
            {activeTab === errorsSummaryTab && (
              <div
                className={`snapshots-content__tabs-content-wrapper relative ${this.getTabContentClassName(errorsSummaryTab)}`}
              >
                <ErrorsSummary
                  msg={msg}
                  exceptionsMsg={exceptionsMsg}
                  snapshotId={snapshotId}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
